<template>
  <div class="emoji-input">
    <div v-for="(item, index) in emojiSet" :key="index" @click="onClick(item)">{{item}}</div>
  </div>
</template>

<script>
export default {
  name: "CommodityMarketingDisccussReviewEmojiInput",
  data() {
    return {
      emojiSet: [
        "😁",
        "😂",
        "😉",
        "😊",
        "😍",
        "😏",
        "😌",
        "😭",
        "💕",
        "👌",
        "🙏",
        "❤️"
      ]
    };
  },
  methods: {
    onClick(e) {
      this.$emit("select", e);
    }
  }
};
</script>

<style lang="less" scoped>
.emoji-input {
  width: 100%;

  div {
    display: inline-block;
    width: 30px;
    text-align: center;
    line-height: 30px;
    height: 30px;
    font-size: 20px;

    cursor: pointer;
  }
}
</style>


